export default {
  methods: {
    capitalize (message) {
      return message.charAt(0).toUpperCase() + message.slice(1)
    }
  }
}
